import { render, staticRenderFns } from "./Kostenaufstellung.vue?vue&type=template&id=a10cd27a"
import script from "./Kostenaufstellung.vue?vue&type=script&lang=js"
export * from "./Kostenaufstellung.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../Documents/GitHub/ogsmyadmin-1/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports